import { render, staticRenderFns } from "./TrademarkOppositionBasisForOppositionFormList.vue?vue&type=template&id=dbfb1662&"
import script from "./TrademarkOppositionBasisForOppositionFormList.vue?vue&type=script&lang=js&"
export * from "./TrademarkOppositionBasisForOppositionFormList.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkOppositionBasisForOppositionFormList.vue?vue&type=style&index=0&id=dbfb1662&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports